import { render, staticRenderFns } from "./AppLoading.vue?vue&type=template&id=284135ae&"
import script from "./AppLoading.vue?vue&type=script&lang=js&"
export * from "./AppLoading.vue?vue&type=script&lang=js&"
import style0 from "./AppLoading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports